import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { allIndividualClients } from "../../../data/Axios/queries";
import { customerservice } from "../../../config";
import IndividualClientsForm from "./form";
import { IndividualClientsColumns } from "../../../data/DynamicTable/Collumns";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { CloudUpload } from "@mui/icons-material";
const base_url = customerservice.uri;
const actions = {
  entity: "Customers",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "customerIds", // Specify the model name here
    inputObjectName: "bulkActivateDeactivateCustomers",
  },
  approveddisapproved: {
    key: "APPROVEDDISAPPROVE",
    button_name: "Disapprove For Credit",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    modelName: "customerIds", // Specify the model name here
    inputObjectName: "bulkApproveRejectCustomersForCredit",
  },
  processCustomeBalance: {
    key: "MARK_TASK_DONE",
    button_name: "Send Credit Balance",
    Show_Button: true,
    swalName: "Sent",
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    dataObject: {
      inputObjectName: "processCustomerOutstandingBalance",
      // inputSubObjectName: "applicationsApprovals",
      inputFields: ["customerPhone", "earliestSaleOrderId", "totalBalance"],
    },
  },
    ViewSummary: {
    key: "VIEWACCOUNTSUMMARY",
    button_name: "Account Summary",
    Show_Button: true,
    permission: "CreatePermission",
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Customer Details"
  },
};
function IndividualClients() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  return (
    <Box m="2px">
      <Box
        m="2px"
        sx={{
          justifyContent: "end",
          alignItems: "center",
          display: "flex",
        }}
      >
        {" "}
        <Typography style={{ color: colors.greenAccent[400], margin: "0 8px" }}>
          Import Customer(s)
        </Typography>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
          sx={{
            backgroundColor: colors.greenAccent[500],
            borderRadius: "4px",
            m: "10px",
          }}
          onClick={handleOpenModal}
        >
          <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
            Import
          </Typography>
        </Button>
      </Box>
      <DynamicTable
        title="Customers"
        subtitle="View all customers, create edit or view details"
        columns={IndividualClientsColumns}
        FormComponent={IndividualClientsForm}
        query={allIndividualClients}
        base_url={base_url}
        //base_url={"https://localhost:7048/graphql/"}
        actions={actions}
        ignoreShowMore={["customerTypeId", "createdBy", "updatedBy", "activatedBy", "creditApprovedBy", "deactivatedBy"]}
        entity={"Customers"}
      />
      {/* <UploadDocumentComponent
        uploadType="individualClient"
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      /> */}
    </Box>
  );
}

export default IndividualClients;
